import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button, Modal } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ChecklistIcon from "@mui/icons-material/Checklist";
import VerAnexos from "../VerAnexos";
import ConsultaGestion from "../ConsultaGestiones";
// eslint-disable-next-line react/prop-types
function ConsultaAsociado({ id, descripcion }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "95%",
    maxWidth: "auto",
    height: "70vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    overflowY: "auto",
  };

  const [columns] = useState([
    { Header: "ID", accessor: "id" },
    { Header: "Nombre Tema", accessor: "nombreTema" },
    { Header: "Título", accessor: "titulo" },
    { Header: "Fecha Creación", accessor: "fechaCreacion" },
    { Header: "Usuario Asignación", accessor: "nombreCreacion" },
    { Header: "Usuario Creación", accessor: "nombreAsignacion" },
    { Header: "Estado", accessor: "name" },
    { Header: "NIT", accessor: "nit" },
    {
      Header: "Ver Anexos",
      accessor: "verAnexos",
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => (
        // eslint-disable-next-line react/prop-types
        <VerAnexos id={row.original.id} />
      ),
    },
    {
      Header: "Ver Gestiones",
      accessor: "verGestion",
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => (
        // eslint-disable-next-line react/prop-types
        <ConsultaGestion id={row.original.id} descripcion={row.original.descripcion} />
      ),
    },
  ]);

  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!id) return;
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://contratosback.azurewebsites.net/api/v1/ObtenerCasoPorId/${id}/`
        );

        const data = response.data.map((item) => ({
          id: item.id,
          idTema: item.idTema,
          nombreTema: item.nombreTema,
          descripcion: item.descripcion,
          titulo: item.titulo,
          fechaCreacion: item.fechaCreacion,
          usuarioCreacion: item.usuarioCreacion,
          nombreCreacion: item.nombreCreacion,
          usuarioAsignacion: item.usuarioAsignacion,
          nombreAsignacion: item.nombreAsignacion,
          idEstado: item.idEstado,
          name: item.name,
          idTipoVinculacion: item.idTipoVinculacion,
          informacionAdicional: item.informacionAdicional,
          nit: item.nit,
        }));

        setRows(data);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    fetchData();
  }, [id]);

  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-crear-caso">Consultar caso asociado</Tooltip>}
      >
        <Button variant="contained" color="primary" onClick={handleOpen}>
          <span style={{ color: "white" }}> Ir al caso</span>
        </Button>
      </OverlayTrigger>

      <Modal open={open} onClose={handleClose} aria-labelledby="modal-title">
        <Box sx={modalStyle}>
          {descripcion}
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button
              onClick={handleClose}
              variant="contained"
              color="light"
              style={{ marginLeft: 10, border: "2px solid blue", color: "blue" }}
            >
              <span style={{ color: "blue" }}>Cerrar</span>
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default ConsultaAsociado;
